import { Text } from "@amzn/stencil-react-components/text";
import React from "react";
import { FormattedMessage } from "react-intl";
/**
 * Interface for FAQ header component
 * @property {string} title - Optional message ID for the header text
 */
interface FAQHeaderProps {
  title?: string;
}

/**
 * Renders a header section for FAQ content
 * @component FAQHeader
 * @param {FAQHeaderProps} props
 * @param {string} props.title - Message ID for internationalized header text
 * @returns {Element} Row component with formatted text title
 */
export const FAQHeader = ({ title }: FAQHeaderProps) => (
  <Text fontSize="T400" dataTestId="selfHelpFAQTitle" className={"faq-header"}>
    <FormattedMessage id={title} />
  </Text>
);
